/* Hand-crank radio landing page behaviour (vanilla JS, no jQuery). Scoped to .hcr-page sections. */
(function () {
  'use strict';

  var desktopMq = window.matchMedia('(min-width: 1081px)');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { el.addEventListener(ev, fn, opts); }

  /* ---------- fade-in on scroll (.sp-fade-box > .sp-ani) ---------- */
  function initFade(root) {
    qsa(root, '.sp-fade-box').concat(root.classList.contains('sp-fade-box') ? [root] : []).forEach(function (box) {
      var items = qsa(box, '.sp-ani');
      if (!items.length) return;
      var show = function () {
        items.forEach(function (el, i) {
          el.style.animation = 'sp-fade-in 1s ease forwards';
          el.style.animationDelay = (i * 0.2 + 0.5) + 's';
        });
      };
      if (designMode || reduceMotion || !('IntersectionObserver' in window)) {
        items.forEach(function (el) { el.style.opacity = 1; });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { show(); io.disconnect(); } });
      }, { threshold: 0.3 });
      io.observe(box);
      root.__hcrCleanup.push(function () { io.disconnect(); });
    });
  }

  /* ---------- sliders (Swiper) ---------- */
  function destroySwiper(el) {
    if (el.__hcrSwiper) { try { el.__hcrSwiper.destroy(true, true); } catch (e) { /* already gone */ } el.__hcrSwiper = null; }
  }
  function marquee(sw) { if (sw && sw.wrapperEl) sw.wrapperEl.style.transitionTimingFunction = 'linear'; return sw; }

  function buildSlider(el, root) {
    destroySwiper(el);
    if (typeof Swiper === 'undefined') return;
    var type = el.getAttribute('data-hcr-slider');
    var isDesktop = desktopMq.matches;
    var auto = function (cfg) { return reduceMotion ? false : cfg; };
    var cfg = null;

    if (type === 'promo') {
      if (el.querySelectorAll('.swiper-slide').length < 2) return;
      cfg = { effect: 'fade', fadeEffect: { crossFade: true }, spaceBetween: 10, speed: 2000, loop: true, autoplay: auto({ delay: 2000, disableOnInteraction: false }) };
    } else if (type === 'tools') {
      if (!isDesktop) return;                                     /* mobile shows the slides stacked */
      cfg = { loop: true, autoplay: auto({ delay: 1500, disableOnInteraction: false }) };
    } else if (type === 'scenarios') {
      cfg = isDesktop
        ? { slidesPerView: 4, spaceBetween: 0, centeredSlides: true, loop: true, freeMode: true, speed: 6500, allowTouchMove: true, autoplay: auto({ delay: 0, disableOnInteraction: false }) }
        : { slidesPerView: 1.6, spaceBetween: 40, centeredSlides: true, loop: true, autoplay: auto({ delay: 1500, disableOnInteraction: false }), pagination: { el: el.querySelector('.swiper-pagination'), clickable: true } };
    } else if (type === 'built') {
      if (isDesktop) return;
      cfg = { loop: true, autoplay: auto({ delay: 1500, disableOnInteraction: false }), pagination: { el: el.querySelector('.swiper-pagination'), clickable: true } };
    } else if (type === 'strip') {
      if (isDesktop) return;
      cfg = { slidesPerView: 'auto', spaceBetween: 40, centeredSlides: true, loop: true, freeMode: true, speed: 6500, autoplay: auto({ delay: 0, disableOnInteraction: false }) };
    }
    if (!cfg) return;
    var sw = new Swiper(el, cfg);
    if (type === 'scenarios' && isDesktop || type === 'strip') marquee(sw);
    el.__hcrSwiper = sw;
    if (type === 'tools') {
      var scope = root;
      var prev = scope.querySelector('.btn.prev'), next = scope.querySelector('.btn.next');
      if (prev) prev.onclick = function () { sw.slidePrev(); };
      if (next) next.onclick = function () { sw.slideNext(); };
    }
  }

  function initSliders(root) {
    var els = qsa(root, '[data-hcr-slider]');
    if (!els.length) return;
    var build = function () { els.forEach(function (el) { buildSlider(el, root); }); };
    var wait = function () { if (typeof Swiper === 'undefined') { setTimeout(wait, 60); } else { build(); } };
    wait();
    var ch = function () { if (typeof Swiper !== 'undefined') build(); };
    desktopMq.addEventListener('change', ch);
    root.__hcrCleanup.push(function () { desktopMq.removeEventListener('change', ch); els.forEach(destroySwiper); });
  }

  /* ---------- FAQ accordion ---------- */
  function slide(el, open) {
    if (reduceMotion) { el.style.display = open ? 'block' : 'none'; return; }
    el.style.overflow = 'hidden';
    if (open) {
      el.style.display = 'block';
      var h = el.scrollHeight;
      el.style.height = '0px';
      void el.offsetHeight;
      el.style.transition = 'height .3s ease';
      el.style.height = h + 'px';
      setTimeout(function () { el.style.height = ''; el.style.transition = ''; el.style.overflow = ''; }, 320);
    } else {
      el.style.height = el.scrollHeight + 'px';
      void el.offsetHeight;
      el.style.transition = 'height .3s ease';
      el.style.height = '0px';
      setTimeout(function () { el.style.display = 'none'; el.style.height = ''; el.style.transition = ''; el.style.overflow = ''; }, 320);
    }
  }
  function initFaq(root) {
    var items = qsa(root, '.sp-qa2-item');
    items.forEach(function (item) {
      var q = item.querySelector('.sp-qa2-question'), a = item.querySelector('.sp-qa2-answer');
      if (!q || !a) return;
      q.setAttribute('role', 'button'); q.setAttribute('tabindex', '0'); q.setAttribute('aria-expanded', item.classList.contains('active') ? 'true' : 'false');
      var toggle = function () {
        var isOpen = item.classList.contains('active');
        items.forEach(function (o) {
          if (o !== item && o.classList.contains('active')) {
            o.classList.remove('active'); o.querySelector('.sp-qa2-question').setAttribute('aria-expanded', 'false'); slide(o.querySelector('.sp-qa2-answer'), false);
          }
        });
        item.classList.toggle('active', !isOpen); q.setAttribute('aria-expanded', String(!isOpen)); slide(a, !isOpen);
      };
      on(q, 'click', toggle);
      on(q, 'keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
    });
  }

  /* ---------- header, menu, anchors ---------- */
  function headerHeight() {
    var w = document.querySelector('.hcr-page .sp_header-wrap.sp-fixed') || document.querySelector('.hcr-page:not([hidden]) .sp_header-wrap');
    return w ? w.getBoundingClientRect().height : 0;
  }
  function initAnchors(root) {
    qsa(root, 'a[href^="#"]').forEach(function (a) {
      var id = a.getAttribute('href').slice(1);
      if (!id) return;
      on(a, 'click', function (e) {
        var t = document.getElementById(id);
        if (!t) return;
        e.preventDefault();
        var top = t.getBoundingClientRect().top + window.pageYOffset - headerHeight() - 20;
        window.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
        var m = document.querySelector('.hcr-page .sp-menu-mask'); if (m) m.style.display = 'none';
      });
    });
  }
  function initHeader(root) {
    var hdr = root.querySelectorAll('.sp_header');
    if (!hdr.length) return;
    var sticky = root.getAttribute('data-sticky') !== 'false';
    var update = function () {
      qsa(root, '.sp_header').forEach(function (h) {
        var wrap = h.querySelector('.sp_header-wrap');
        if (!wrap) return;
        var past = h.getBoundingClientRect().bottom < 0;
        wrap.classList.toggle('sp-fixed', sticky && past);
      });
    };
    on(window, 'scroll', update, { passive: true }); update();
    root.__hcrCleanup.push(function () { window.removeEventListener('scroll', update); });
    var btn = root.querySelector('.sp-menu-btn'), mask = root.querySelector('.sp-menu-mask'), close = root.querySelector('.sp-close-btn');
    [btn, close].forEach(function (el) { if (el) { el.setAttribute('role', 'button'); el.setAttribute('tabindex', '0'); on(el, 'keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); el.click(); } }); } });
    if (btn && mask) {
      on(btn, 'click', function () { mask.style.display = 'block'; });
      on(mask, 'click', function (e) { if (e.target === mask || e.target === close) mask.style.display = 'none'; });
      on(document, 'keydown', function (e) { if (e.key === 'Escape') mask.style.display = 'none'; });
    }
  }

  /* ---------- sticky mobile bar ---------- */
  function initStickyBar(root) {
    var bar = root.querySelector('.sp-btn-style2');
    if (!bar) return;
    var threshold = parseInt(root.getAttribute('data-show-after'), 10) || 800;
    var buy = document.querySelector('[data-hcr-buy]');
    var buyVisible = false;
    if (buy && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { buyVisible = en[0].isIntersecting; update(); });
      io.observe(buy);
      root.__hcrCleanup.push(function () { io.disconnect(); });
    }
    function update() { bar.style.display = (window.pageYOffset > threshold && !buyVisible) || designMode ? 'flex' : 'none'; }
    on(window, 'scroll', update, { passive: true }); update();
    root.__hcrCleanup.push(function () { window.removeEventListener('scroll', update); });
  }

  /* ---------- videos: play only while visible ---------- */
  function initVideos(root) {
    var vids = qsa(root, 'video[data-hcr-video]');
    if (!vids.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) {
        if (e.isIntersecting && !reduceMotion) { var p = e.target.play(); if (p && p.catch) p.catch(function () {}); } else { e.target.pause(); }
      });
    }, { threshold: 0.3 });
    vids.forEach(function (v) { io.observe(v); });
    root.__hcrCleanup.push(function () { io.disconnect(); });
  }

  /* ---------- cart count ---------- */
  function setCartCount(n) {
    qsa(document, '.hcr-cart-count').forEach(function (el) {
      el.textContent = n; el.classList.toggle('sp-gray', !(n > 0));
    });
  }
  function refreshCart() {
    fetch((window.routes && window.routes.cart_url ? window.routes.cart_url.replace(/\/$/, '') : '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (c) { setCartCount(c.item_count); }).catch(function () {});
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    try { subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCart); } catch (e) { /* theme without pubsub */ }
  }

  /* ---------- genuine countdown (only runs when the merchant sets an end date) ---------- */
  function initCountdown(root) {
    qsa(root, '[data-hcr-countdown]').forEach(function (cd) {
      var end = Date.parse(cd.getAttribute('data-hcr-countdown'));
      if (isNaN(end)) { cd.hidden = true; return; }
      var h = cd.querySelector('[data-cd="h"]'), m = cd.querySelector('[data-cd="m"]'), s = cd.querySelector('[data-cd="s"]');
      var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
      var tick = function () {
        var left = end - Date.now();
        if (left <= 0) { cd.hidden = true; clearInterval(t); var wrap = cd.closest('[data-hcr-countdown-wrap]'); if (wrap && wrap.getAttribute('data-hide-ended') !== 'false') wrap.hidden = true; return; }
        h.textContent = pad(Math.floor(left / 3600000)); m.textContent = pad(Math.floor(left / 60000) % 60); s.textContent = pad(Math.floor(left / 1000) % 60);
      };
      var t = setInterval(tick, 1000); tick();
      root.__hcrCleanup.push(function () { clearInterval(t); });
    });
  }

  /* ---------- buy box: variants, price, image, quantity ---------- */
  function initBuy(root) {
    var box = root.querySelector('[data-hcr-buy]');
    if (!box) return;
    var dataEl = box.querySelector('[data-hcr-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = box.querySelector('input[name="id"]');
    var priceEl = box.querySelector('[data-hcr-price]'), compareEl = box.querySelector('[data-hcr-compare]'), offEl = box.querySelector('[data-hcr-off]');
    var atc = box.querySelector('[data-hcr-atc]'), atcLabel = box.querySelector('[data-hcr-atc-label]');
    var mainImg = box.querySelector('[data-hcr-main-img]');
    var optionBtns = qsa(box, '[data-hcr-option]');
    var optionNames = qsa(box, '[data-hcr-option-current]');
    var nOptions = optionNames.length || 1;
    var selected = [];
    optionBtns.forEach(function (b) { if (b.classList.contains('active')) selected[+b.getAttribute('data-index')] = b.getAttribute('data-value'); });

    function find() {
      return variants.filter(function (v) {
        for (var i = 0; i < nOptions; i++) { if (selected[i] != null && v.options[i] !== selected[i]) return false; }
        return true;
      })[0];
    }
    function paintAvailability() {
      optionBtns.forEach(function (b) {
        var idx = +b.getAttribute('data-index'), val = b.getAttribute('data-value');
        var any = variants.some(function (v) {
          if (v.options[idx] !== val || !v.available) return false;
          for (var i = 0; i < nOptions; i++) { if (i !== idx && selected[i] != null && v.options[i] !== selected[i]) return false; }
          return true;
        });
        b.classList.toggle('is-soldout', !any);
      });
    }
    function apply() {
      var v = find();
      if (!v) { if (atc) { atc.disabled = true; atcLabel.textContent = box.getAttribute('data-unavailable'); } return; }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price;
      if (compareEl) { compareEl.textContent = v.compare || ''; compareEl.hidden = !v.compare; }
      if (offEl) { var wrap = offEl.closest('[data-hcr-off-wrap]'); offEl.textContent = v.off || ''; if (wrap) wrap.hidden = !v.off; }
      optionNames.forEach(function (n) { n.textContent = selected[+n.getAttribute('data-index')] || ''; });
      if (atc) { atc.disabled = !v.available; atcLabel.textContent = v.available ? box.getAttribute('data-atc-label') : box.getAttribute('data-soldout-label'); }
      var pay = box.querySelector('.shopify-payment-button'); if (pay) pay.hidden = !v.available;
      if (mainImg && v.image) { mainImg.src = v.image; mainImg.removeAttribute('srcset'); if (v.imageAlt) mainImg.alt = v.imageAlt; }
      optionBtns.forEach(function (b) {
        var on_ = selected[+b.getAttribute('data-index')] === b.getAttribute('data-value');
        b.classList.toggle('active', on_); b.setAttribute('aria-pressed', on_ ? 'true' : 'false');
      });
      paintAvailability();
      if (!designMode && window.history && history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString());
      }
    }
    optionBtns.forEach(function (b) {
      on(b, 'click', function () { selected[+b.getAttribute('data-index')] = b.getAttribute('data-value'); apply(); });
    });
    paintAvailability();

    qsa(box, '[data-hcr-thumb]').forEach(function (t) {
      on(t, 'click', function () {
        if (!mainImg) return;
        mainImg.src = t.getAttribute('data-src'); mainImg.removeAttribute('srcset'); mainImg.alt = t.getAttribute('data-alt') || mainImg.alt;
      });
    });

    var qty = box.querySelector('input[name="quantity"]');
    var minus = box.querySelector('[data-hcr-qty-minus]'), plus = box.querySelector('[data-hcr-qty-plus]');
    var clamp = function () { var n = parseInt(qty.value, 10); if (isNaN(n) || n < 1) n = 1; if (n > 99) n = 99; qty.value = n; };
    if (qty) {
      if (minus) on(minus, 'click', function () { qty.value = (parseInt(qty.value, 10) || 1) - 1; clamp(); });
      if (plus) on(plus, 'click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; clamp(); });
      on(qty, 'change', clamp);
    }
  }

  /* ---------- wiring ---------- */
  function initRoot(root) {
    if (root.__hcrInit) return;
    root.__hcrInit = true;
    root.__hcrCleanup = [];
    initFade(root); initSliders(root); initFaq(root); initHeader(root); initAnchors(root);
    initStickyBar(root); initVideos(root); initCountdown(root); initBuy(root);
  }
  function destroyRoot(root) {
    (root.__hcrCleanup || []).forEach(function (fn) { try { fn(); } catch (e) { /* ignore */ } });
    root.__hcrInit = false;
  }
  function initAll() { qsa(document, '.hcr-page').forEach(initRoot); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', function (e) { qsa(e.target, '.hcr-page').forEach(initRoot); });
  document.addEventListener('shopify:section:unload', function (e) { qsa(e.target, '.hcr-page').forEach(destroyRoot); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });
})();
